module.exports = __webpack_public_path__ + "img/arrival_15.78bf049d.jpg";